<template>
  <el-pagination
      :current-page="pageTemp.current"
      :page-size="pageTemp.size"
      :page-sizes="[10, 20, 30, 1000]"
      :total="pageTemp.total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      layout="total, sizes, prev, pager, next, jumper">
  </el-pagination>
</template>

<script>
export default {
  name: 'Pagination',

  model: {
    prop: 'page',
    event: 'change',
  },

  props: {
    page: {
      type: Object,
      default: () => ({
        current: 1,
        size: 10,
        total: 0,
      }),
    },
  },

  data() {
    return {
      pageTemp: {...this.page},  // 直接使用 props 初始化数据
    };
  },

  watch: {
    // 监听 page 的变化，保持 pageTemp 同步
    page: {
      deep: true,
      handler(newVal) {
        this.pageTemp = {...newVal};
      }
    }
  },

  methods: {
    handleSizeChange(val) {
      this.pageTemp.size = val;
      this.$emit('change', {...this.pageTemp});
      this.$emit('updated');
    },

    handleCurrentChange(val) {
      this.pageTemp.current = val;
      this.$emit('change', {...this.pageTemp});
      this.$emit('updated');
    },
  },
};
</script>

<style scoped>
</style>
